import dayjs from 'dayjs';

export const createDateRenderer = (column: string) => (record: any) => record[column] && dayjs(record[column]).format('YYYY-MM-DD HH:mm');
